import { Button, ButtonGroup, TextField } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { addSupplier } from "../../redux/features/suppliers.features";

const initialValues = {
  firstName: "",
  lastName: "",
  homeAddress: "",
  businessAddress: "",
  country: "Sri Lanka",
  city: "Beruwala",
  mobile: "",
  email: "",
  status: "Active",
};

const SupplierEntry = () => {
  const dispatch = useDispatch()
  const [values, setValues] = useState(initialValues);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="row card__body">
            <div className="col-6">
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="Supplier id"
                defaultValue=""
                color="warning"
                margin="dense"
                name="id"
                disabled
                onChange={handleChange}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="firstName"
                placeholder="John.. "
                name="firstName"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.firstName}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                rows={4}
                id="outlined-required"
                label="lastName"
                placeholder="lastName"
                defaultValue=""
                color="warning"
                name="lastName"
                value={values.lastName}
                onChange={handleChange}
              />
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                multiline
                rows={4}
                id="outlined-required"
                label="homeAddress"
                placeholder="homeAddress"
                defaultValue=""
                color="warning"
                name="homeAddress"
                value={values.homeAddress}
                onChange={handleChange}
              />
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                multiline
                rows={4}
                id="outlined-required"
                label="businessAddress"
                placeholder="businessAddress"
                defaultValue=""
                color="warning"
                name="businessAddress"
                value={values.businessAddress}
                onChange={handleChange}
              />
            </div>
            <div className="col-6">
              <CustomSelectBox
                items={["Sri Lanka", "Singapore", "Tanzania", "USA", "UK"]}
                onChange={handleChange}
                title="country"
                name="country"
                value={values.country}
              />

              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                id="outlined-required"
                label="city"
                placeholder="city"
                name="city"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.city}
              />
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                type="number"
                id="outlined-required"
                label="mobile"
                placeholder="mobile"
                name="mobile"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.mobile}
              />
              <TextField
                style={{ color: "white", marginBottom: 16 }}
                fullWidth
                required
                type="email"
                id="outlined-required"
                label="email"
                placeholder="email"
                name="email"
                defaultValue=""
                color="warning"
                onChange={handleChange}
                value={values.email}
              />
                <CustomSelectBox
                items={["Active", "DeActive"]}
                onChange={handleChange}
                title="Status"
                name="status"
                value={values.status}
              />
              <div style={{marginBottom:150}}></div>
              
              <ButtonGroup
               
                fullWidth
                variant="contained"
                aria-label="outlined primary button group"
              >
                <Button color="warning">Cancel</Button>

                <Button onClick={e=>dispatch(addSupplier(values))} color="success">Save</Button>
              </ButtonGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierEntry;
